import React, { Component } from 'react'

import _ from 'lodash'

import { withTranslation } from 'react-i18next'

import { sectionCommunicator } from '../../../communicators/sectionCommunicator'

import { Page } from '../Page/Page'
import { SectionItem } from '../SectionsList/SectionsList'

class SectionPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            section: null,
            isLoading: true
        }
    }

    loadSection = async () => {
        try {
            const { slug } = this.props.match.params
            const section = await sectionCommunicator.fetchSingleSection(slug)

            this.setState({ section, isLoading: false })
        } catch (error) {
            console.error(error)
            this.setState({ isLoading: false })
        }
    }

    componentDidMount() {
        this.loadSection()
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.slug !== prevProps.match.params.slug) {
            this.loadSection()
        }
    }

    render() {
        const { section, isLoading } = this.state
        const { t } = this.props

        if (_.isEmpty(section)) {
            return <Page isLoading={isLoading} />
        }
        const { title, sectionDescription } = section

        return (
            <Page
                isLoading={isLoading}
                title={`${t('headTitle')}/${title}`}
                description={sectionDescription}
            >
                <SectionItem section={section} dark />
            </Page>
        )
    }
}

export default withTranslation()(SectionPage)
